<template>
  <div id="Home">
    <section id="key-vision" class="bg-secondary-dark">
      <hooper
        class="h-100"
        :itemsToShow="1"
        :infiniteScroll="true"
        :autoPlay="true"
        :playSpeed="10000"
        :wheelControl="false"
      >
        <slide>
          <div class="kv-bg" v-lazy:background-image="require('@/assets/image/banner-1.png')" />
        </slide>
        <slide>
          <div class="kv-bg" v-lazy:background-image="require('@/assets/image/banner-2.png')" />
        </slide>
      </hooper>
      <div
        ref="title"
        class="title w-100 d-flex flex-column align-items-center justify-content-center"
        data-aos="zoom-in-up"
        data-aos-easing="ease-out-back"
        data-aos-delay="50"
        data-aos-duration="700"
        :style="parallaxStyle"
      >
        <h1 class="h2 text-white text-center px-15 px-md-0">
          台灣唯一
          <br class="d-md-none" />全方位美學生活
          <br class="d-md-none" />領先體驗
        </h1>
      </div>
    </section>
    <section id="news-part">
      <div class="container">
        <div class="row">
          <div
            class="card-content col-lg-4 col-sm-6 my-15"
            v-for="(item, index) in news"
            :key="index"
          >
            <div class="card h-100">
              <div class="card-img-top">
                <div
                  class="img w-100 rounded-top"
                  v-lazy:background-image="{src: item.media.data.length>0 && item.media.data[0].medium, error: require('@/assets/image/demo-counter.png')}"
                ></div>
              </div>
              <div class="card-body p-0">
                <div class="form-row h-100">
                  <div class="col-12">
                    <div class="desc p-10 pr-15">
                      <p class="mt-5 pb-5">
                        <small>{{ item.created_at | date }}</small>
                      </p>
                      <p class="my-10">{{item.title}}</p>
                      <p class="content my-5">
                        <small>{{item.content}}</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="app-download">
      <div class="container-desc container py-50">
        <div class="row">
          <div class="col-4 d-md-flex align-items-center justify-content-center d-none">
            <img
              v-lazy="'img/mobile-sample.png'"
              alt="app detail"
              height="350"
              data-aos="fade-up"
              data-aos-easing="ease-out-back"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-anchor-placement="bottom-bottom"
            />
          </div>
          <div class="col-md-8">
            <div class="desc">
              <h2 class="text-primary-light">成為H'S VIBE齊來卡會員好處</h2>
              <p class="my-15">手機APP商店搜尋「H'S VIBE 齊來卡」免費申請成為會員， 獨享眾多禮遇！專屬會員權益：</p>
              <ol class="pl-10">
                <li>於各特約商單筆消費滿10元集0.03點， 滿20元集0.06點，以此類推</li>
                <li>於手機內兌換優惠券， 即換即用， 優惠券種類多元價值無上限</li>
                <li>申請會員成功即贈送30點， 讓您立即享有優惠</li>
                <li>獨家好禮與各特約商不定期專屬優惠</li>
              </ol>
              <div
                class="download d-none d-md-flex align-items-center justify-content-start mt-50"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-out-back"
                data-aos-duration="800"
                data-aos-anchor-placement="center-bottom"
              >
                <div>
                  <a
                    href="https://apps.apple.com/tw/app/hs-vibe-%E9%BD%8A%E4%BE%86%E5%8D%A1/id1449947800?l=en"
                  >
                    <img src="@/assets/image/appstore.png" alt="Download on the App Store" />
                  </a>
                </div>
                <div class="ml-20">
                  <a href="https://play.google.com/store/apps/details?id=com.hsvibe">
                    <img src="@/assets/image/googleplay.png" alt="Get it on Google Play" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="second-app py-50 d-md-none">
        <div class="container d-flex flex-column align-items-center justify-content-center">
          <img
            v-lazy="'img/mobile-sample.png'"
            alt="app detail"
            height="350"
            data-aos="fade-up"
            data-aos-easing="ease-out-back"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          />
          <div
            class="download mt-50"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-out-back"
            data-aos-duration="800"
            data-aos-anchor-placement="center-bottom"
          >
            <div>
              <a
                href="https://apps.apple.com/tw/app/hs-vibe-%E9%BD%8A%E4%BE%86%E5%8D%A1/id1449947800?l=en"
              >
                <img src="@/assets/image/appstore.png" alt="Download on the App Store" />
              </a>
            </div>
            <div class="mt-20">
              <a href="https://play.google.com/store/apps/details?id=com.hsvibe">
                <img src="@/assets/image/googleplay.png" alt="Get it on Google Play" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="index-special-offer" class="bg-secondary">
      <div class="container">
        <h2 class="text-sub-primary text-center mb-50">會員專屬優惠</h2>
        <div
          class="card-columns"
          data-aos="fade-up"
          data-aos-easing="ease-out-back"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-anchor-placement="top-bottom"
        >
          <div class="card" v-for="(item, index) in coupon" :key="index">
            <router-link :to="{name:'Coupon', params:{id:item.id}}">
              <div
                class="card-img-top"
                v-lazy:background-image="{src: item.media.data.length>0 && item.media.data[0].medium, error: require('@/assets/image/demo-coupon.jpg')}"
              >
                <div
                  class="badge text-white"
                  :style="{'background-color': item.stores.data.length>0 && item.stores.data[0].color !== '' ? item.stores.data[0].color : '#fa6400'}"
                >
                  <span>{{item.brand_name}}</span>
                </div>
              </div>
              <div class="card-body p-15 d-flex flex-column justify-content-between">
                <div class="form-row">
                  <div class="col-12">
                    <div class="card-title m-0">
                      <h6 class="title m-0">{{item.title}}</h6>
                      <p class="desc m-0">{{item.subtitle}}</p>
                    </div>
                  </div>
                </div>
                <div class="card-text d-flex align-items-center justify-content-start">
                  <Icons name="product" color="#eec273" />
                  <p class="h5 m-0 ml-10 font-weight-bolder">{{item.point}}</p>
                  <p class="m-0 ml-auto">
                    <small>
                      <span class="d-md-none d-lg-inline">有效期限</span>
                      {{item.expire_at | date}}
                    </small>
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <router-link :to="{name:'Special-Offer'}">
          <button
            class="btn btn-primary-light d-flex mx-auto px-40 mt-25"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-out-back"
            data-aos-duration="800"
            data-aos-anchor-placement="center-bottom"
          >更多優惠</button>
        </router-link>
      </div>
    </section>
    <section id="Collaboration-part" ref="Collaboration">
      <div class="container">
        <!-- <h2 class="text-primary text-center mb-40">合作商家</h2> -->
        <Partners
          data-aos="fade-up"
          data-aos-easing="ease-out-back"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-anchor-placement="top-bottom"
        ></Partners>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icons from '@/components/icon.vue';
import Partners from '@/components/Partners.vue';
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: 'Home',
  metaInfo: {
    title: '首頁 | ',
  },
  components: {
    Icons,
    Partners,
    Hooper,
    Slide,
  },
  data() {
    return {
      coupon: [],
      news: [],
      parallaxStyle: {
        opacity: 1,
      },
      hooperSettings: {
        itemsToShow: 1,
        centerMode: true,
        infiniteScroll: true,
        pagination: 'fraction',
        breakpoints: {
          992: {
            centerMode: false,
            itemsToShow: 2,
          },
        },
      },
    };
  },
  props: {
    section: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['screenWidth', 'scrollY']),
  },
  methods: {
    getCoupon() {
      const url = '/coupon';
      const params = {
        limit: 9,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.coupon = response.data.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getNews() {
      const url = '/content';
      const params = {
        limit: 6,
        category_id: 5,
        orderBy: 'updated_at',
        sortedBy: 'desc',
        page: 1,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.news = response.data.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    breakFilter(text) {
      return text.split('\n');
    },
  },
  mounted() {
    this.getCoupon();
    this.getNews();
    if (this.$route.params.section) {
      const target = this.$route.params.section;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target].scrollIntoView();
        }, 800);
      });
    }
  },
  watch: {
    scrollY(val) {
      if (val >= 100 && val < 300) {
        this.parallaxStyle.opacity = 0.5;
      } else if (val >= 300) {
        this.parallaxStyle.opacity = 0;
      } else {
        this.parallaxStyle.opacity = 1;
      }
    },
    section(value) {
      if (value) {
        this.$refs[value].scrollIntoView();
        this.$nextTick(() => {
          this.$emit('finish');
        }, 500);
      }
    },
  },
};
</script>
<style lang="scss">
#Home {
  #key-vision {
    height: 450px;
    @media (min-width: 576px) {
      height: 550px;
    }
    .kv-bg {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: $secondary-dark;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .title {
      position: fixed;
      top: 30%;
      transition: 0.3s ease-out;
      @media (min-width: 768px) {
        top: 40%;
      }
      h1 {
        letter-spacing: 4px;
      }
      button {
        opacity: 0.9;
      }
    }
  }
  #news-part {
    padding: 80px 0;
    min-height: 200px;
    background-image: url('~@/assets/image/bg-black.png');
    // background-color: $sub-primary;
    background-size: cover;
    background-position: center center;
    position: relative;
    // &::before {
    //     content: '';
    //     position: absolute;
    //     top: 0;
    //     bottom: 0;
    //     left: 0;
    //     right: 0;
    //     background-color: rgba(255, 255, 255, 0.5);
    //   }
    .card-content {
      .card {
        border: 0;
        .img {
          background-size: cover;
          background-position: center center;
          // border-top-left-radius: 5px;
          // border-top-right-radius: 5px;
          max-height: 300px;
          height: calc((100vw - 30px) * 2 / 3);
          @media (min-width: 576px) {
            height: calc((540px / 2 - 30px) * 2 / 3);
          }
          @media (min-width: 768px) {
            height: calc((720px / 2 - 30px) * 2 / 3);
          }
          @media (min-width: 992px) {
            height: calc((960px / 3 - 30px) * 2 / 3);
          }
          @media (min-width: 1200px) {
            height: calc((1140px / 3 - 30px) * 2 / 3);
          }
        }
        p {
          line-height: 1.25;
        }
        .desc {
          .content {
            display: -webkit-box !important;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }
      &:nth-child(odd) {
        .card {
          background: linear-gradient(90deg, #ffffff 50%, #d1d1d1);
          .desc {
            p:first-of-type {
              border-bottom: 2px solid $secondary-white;
            }
          }
        }
      }
      &:nth-child(even) {
        .card {
          background: linear-gradient(90deg, #b7c5e4 20%, #1f2532);
          color: white;
          .desc {
            p:first-of-type {
              border-bottom: 2px solid $secondary-light;
            }
          }
        }
      }
    }
  }
  #app-download {
    min-height: 550px;
    @media (min-width: 576px) {
      background-image: url('~@/assets/image/bg-white.png');
      background-size: cover;
    }
    @media (min-width: 768px) {
      padding: 50px 0;
    }
    .container-desc {
      z-index: 10;
      background-image: url('~@/assets/image/bg-white.png');
      background-size: auto 100%;
      @media (min-width: 576px) {
        background: none;
      }
      .desc {
        h2 {
          text-align: center;
          @media (min-width: 576px) {
            text-align: left;
          }
        }
        ol {
          list-style: none;
          counter-reset: li;
          li {
            counter-increment: li;
            margin: 10px 0;
            position: relative;
            padding-left: 30px;
            &::before {
              position: absolute;
              content: counter(li);
              color: $sub-primary;
              display: inline-block;
              width: 25px;
              height: 25px;
              left: 0;
              top: 3px;
              text-align: center;
              background: $primary;
              line-height: 25px;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .download {
      width: 160px;
      max-width: 70%;
      @media (min-width: 768px) {
        width: 100%;
        max-width: 600px;
      }
      img {
        width: 100%;
        max-width: 250px;
        height: auto;
      }
    }
    .second-app {
      background: linear-gradient(to right, $primary-light 60%, $primary);
    }
  }
  #index-special-offer {
    background-image: url('~@/assets/image/bg-black.png');
    background-size: cover;
    padding: 80px 0;
    .card-columns {
      column-gap: 30px;
      column-count: 1;
      @media (min-width: 768px) {
        column-count: 3;
      }
    }
    .card {
      margin-bottom: 25px;
      height: 550px;
      border: none;
      a {
        color: unset;
      }
      .card-img-top {
        position: relative;
        height: 400px;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        .badge {
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      }
      .card-body {
        height: 150px;
        p,
        h6,
        span,
        small {
          letter-spacing: normal;
        }
        .desc {
          max-width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          @media (min-width: 768px) {
            -webkit-line-clamp: 1;
          }
          @media (min-width: 992px) {
            -webkit-line-clamp: 2;
          }
        }
      }
      @media (min-width: 768px) {
        &:nth-child(1),
        &:nth-child(9) {
          height: 450px;
          .card-img-top {
            height: 300px;
          }
        }
        &:nth-child(3),
        &:nth-child(7) {
          height: 650px;
          .card-img-top {
            height: 500px;
          }
        }
      }
      &:nth-child(even) {
        background: linear-gradient(to right, #ffffff -33%, #d1d1d1);
      }
      &:nth-child(odd) {
        background: linear-gradient(to right, #b7c5e4 -47%, #41495a 63%, $secondary-dark 100%);
        color: white;
      }
    }
  }
  #Collaboration-part {
    padding: 50px 0;
    // background-image: url('~@/assets/image/bg-black.png');
    // background-size: cover;
    // background-position: center bottom;
    // background-image: url('~@/assets/image/gold-black.png');
  }
}
</style>
